import { defineComponent as _defineComponent } from 'vue'
import axios from 'axios'
import { getCurrentInstance, onMounted, ref } from 'vue'

type NoticeInfo = {
  linkurl: string
  /** '1' なら別タブで開く。API は文字列/数値どちらも返しうる */
  linktarget: string | number
  contexts: string
}

type VarunaClient = { endPoints: { getNoticeinformation: string } }


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNoticeBar',
  setup(__props) {

/**
 * トップの1行お知らせ帯。varuna から取った先頭1件だけ出す。
 *
 * Top.vue（1,700行超）の分解で切り出した。取得も表示もこの中で完結する。
 *
 * ⚠️ 中身はビルド時に存在しない API 取得コンテンツなので、Top.vue 側では
 * <!-- static:skip --> で囲んで静的トップ(public/top-content.html)から外す。
 */
const varuna = (
  getCurrentInstance()!.proxy as unknown as { $varuna: VarunaClient }
).$varuna

const noticeInfo = ref<NoticeInfo | null>(null)

onMounted(() => {
  axios
    .post(varuna.endPoints.getNoticeinformation, new FormData(), {
      timeout: 60000
    })
    .then((response) => {
      const noticeList = response.data && response.data.notice_list
      if (noticeList) {
        noticeInfo.value = (Object.values(noticeList)[0] as NoticeInfo) || null
      }
    })
    .catch((error) => {
      // 取れなくてもトップは出す（v-if で丸ごと消える）
      console.error('お知らせの取得エラー', error)
    })
})

return { __sfc: true,varuna, noticeInfo }
}

})